export { Music as default } from './Music';
